exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.markdown-renderer[data-v-df6d1aa6] pre {\n  background-color: #f5f5f5;\n  padding: 10px;\n  border-radius: 4px;\n  overflow-x: auto;\n}\n.markdown-renderer[data-v-df6d1aa6] code {\n  font-family: monospace;\n  background-color: rgba(27, 31, 35, 0.05);\n  padding: 0.2em 0.4em;\n  border-radius: 3px;\n}\n.markdown-renderer[data-v-df6d1aa6] blockquote {\n  border-left: 4px solid #dfe2e5;\n  color: #6a737d;\n  padding: 0 1em;\n  margin-left: 0;\n}\n", ""]);

// exports
